/**
 * Gatekeeper 根地址（去尾斜杠）。OAuth、token 等接口仍用此根拼接 `/api/...`。
 */
export function getGatekeeperBaseUrl(): string {
  return (import.meta.env.VITE_GATEKEEPER_URL || 'https://test-gatekeeper.xmslol.cn').replace(/\/+$/, '');
}

/**
 * 权限自助申请入口（与 SecurityBlock / AppLayout 等「申请权限」按钮一致）。
 * - 未配置：打开 Gatekeeper 首页（历史默认）
 */
export function getPermissionApplyUrl(): string {
  const base = getGatekeeperBaseUrl();
  return `${base}/apply`;
}
